import { render } from "./RemoteData.vue?vue&type=template&id=3ade1d2b&scoped=true"
import script from "./RemoteData.vue?vue&type=script&lang=js"
export * from "./RemoteData.vue?vue&type=script&lang=js"

import "./RemoteData.vue?vue&type=style&index=0&id=3ade1d2b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ade1d2b"]])

export default __exports__